import { Application, ResolvedRouteChild, ResolvedRoutesConfig } from "single-spa-layout/dist/types/isomorphic/constructRoutes";

/**
 * Filters the given route config to remove all applications which are not admissible.
 *
 * @example
 * import {constructRoutes } from "single-spa-layout";
 * const routes = constructRoutes(layout, { props: {}, loaders: {} });
 * filterRoutes(routes, ["@newsenec/bad-micro-frontend", "@newsenec/very-bad-micro-frontend"]);
 * const applications = constructApplications({ routes, loadApp: ({ name }) => System.import(name) })
 *
 * @param routesConfig routes config, is modified by the filtering
 * @param admissibleMfs name of all admissible micro frontends.
 */
export const filterRoutes = (routesConfig: ResolvedRoutesConfig, admissibleMfs: string[]): void =>
    filterDeepRoutesArray(routesConfig.routes, admissibleMfs);

export type RoutesType = ResolvedRouteChild | SimpleRouteChild;
type SimpleRouteChild = { routes?: Array<unknown>; type?: string; name?: string };

const filterDeepRoutesArray = (routes: Array<RoutesType>, admissibleMfs: string[]): void => {
    for (let i = 0; i < routes.length; ) {
        const route = routes[i];
        if (isApplication(route) && !admissibleMfs.includes(route.name)) {
            routes.splice(i, 1);
        } else {
            if (hasRoutes(route)) {
                filterDeepRoutesArray(route.routes, admissibleMfs);
                if (route.routes.length === 0) {
                    routes.splice(i, 1);
                    continue;
                }
            }
            i++;
        }
    }
};

export const isApplication = (route: RoutesType): route is Application =>
    "type" in route && "name" in route && route.type === "application";

export const hasRoutes = (route: RoutesType): route is { routes: Array<RoutesType> } =>
    "routes" in route && Array.isArray(route.routes);
